import { ChevronLeft } from 'lucide-react';

import { cn } from '@/lib/shadcn/lib/utils';

import { BackToPageButton } from '../back-to-page-button/back-to-page-button';
import { SideMenu } from '../side-menu/side-menu';

type Props = {
  left?: boolean;
  middleContent?: React.ReactNode;
  right?: boolean;
  className?: string;
  goBack?: () => void;
  goBackFallback?: () => void;
  goBackDisabled?: boolean;
};

export const PageHeader: React.FC<React.PropsWithChildren<Props>> = ({
  left = false,
  middleContent,
  right = false,
  className,
  goBack,
  goBackFallback,
  goBackDisabled,
}) => {
  return (
    <header className={cn('flex items-center gap-unit-2', className)}>
      {left ? (
        <BackToPageButton
          variant="elongatedSquare"
          size="md"
          onClick={goBack}
          fallback={goBackFallback}
          disabled={goBackDisabled}
          data-testid="go-back-button"
          className="shrink-0"
        >
          <ChevronLeft className="text-slate-500" />
        </BackToPageButton>
      ) : null}
      <div className="min-w-0 flex-1 overflow-hidden">{middleContent}</div>
      {right ? <SideMenu /> : null}
    </header>
  );
};
